import React, { useState, useRef, useEffect } from 'react';
import { COLORS_CONSTANTS } from '../constants/Colors';

export const OTPInput = ({ otpBoxCount, onChange, className = '', inputClassName = '' }) => {
  const [otp, setOtp] = useState(Array(otpBoxCount).fill(''));
  const inputs = useRef([]);

  useEffect(() => {
    inputs.current[0]?.focus();
  }, []);

  const emitChange = (next) => {
    setOtp(next);
    onChange(next.join(''));
  };

  const handleChange = (value, idx) => {
    if (!/^\d?$/.test(value)) return;
    const newOtp = [...otp];
    newOtp[idx] = value;
    emitChange(newOtp);
    if (value && idx < otpBoxCount - 1) inputs.current[idx + 1]?.focus();
  };

  const handleKeyDown = (e, idx) => {
    if (e.key === 'Backspace' && !otp[idx] && idx > 0) {
      inputs.current[idx - 1]?.focus();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pasted = e.clipboardData.getData('text').replace(/\D/g, '').slice(0, otpBoxCount);
    if (!pasted) return;
    const next = Array(otpBoxCount).fill('');
    pasted.split('').forEach((digit, i) => {
      next[i] = digit;
    });
    emitChange(next);
    const focusIdx = Math.min(pasted.length, otpBoxCount - 1);
    inputs.current[focusIdx]?.focus();
  };

  return (
    <div className={className} style={className ? undefined : { display: 'flex', gap: 6, justifyContent: 'center' }}>
      {otp?.map((digit, idx) => (
        <input
          key={idx}
          ref={(el) => {
            inputs.current[idx] = el;
          }}
          className={inputClassName ? `${inputClassName}${digit ? ' is-filled' : ''}` : undefined}
          type="text"
          inputMode="numeric"
          autoComplete={idx === 0 ? 'one-time-code' : 'off'}
          maxLength={1}
          value={digit}
          onChange={(e) => handleChange(e.target.value, idx)}
          onKeyDown={(e) => handleKeyDown(e, idx)}
          onPaste={handlePaste}
          style={
            inputClassName
              ? undefined
              : {
                  width: 50,
                  height: 50,
                  textAlign: 'center',
                  borderRadius: '100px',
                  justifyContent: 'center',
                  fontSize: 24,
                  fontWeight: 700,
                  color: COLORS_CONSTANTS.PAGE_TEXT,
                  background: COLORS_CONSTANTS.TEXT_INPUT_BACKGROUND_1,
                  border: `2px solid ${COLORS_CONSTANTS.GLASS_BORDER}`,
                  boxShadow: COLORS_CONSTANTS.GLASS_SHADOW,
                  backdropFilter: `blur(${COLORS_CONSTANTS.GLASS_BLUR})`,
                  WebkitBackdropFilter: `blur(${COLORS_CONSTANTS.GLASS_BLUR})`,
                  boxSizing: 'border-box',
                }
          }
        />
      ))}
    </div>
  );
};
